/* Dr. Hugo – Global JavaScript */
(function () {
  'use strict';

  /* ── Scroll Reveal ── */
  function initScrollReveal() {
    var els = document.querySelectorAll('[data-anim]');
    if (!els.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ── Sticky header shrink ── */
  function initStickyHeader() {
    var header = document.getElementById('dh-header');
    if (!header) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          if (window.scrollY > 60) {
            header.classList.add('is-scrolled');
          } else {
            header.classList.remove('is-scrolled');
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ── Smooth anchor scroll ── */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.querySelector(a.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        var header = document.getElementById('dh-header');
        var offset = header ? header.offsetHeight + 16 : 80;
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  /* ── Cart open/close ── */
  function initCart() {
    var cartLinks = document.querySelectorAll('[href="/cart"]');
    cartLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (window.Shopify && window.Shopify.theme) {
          /* let Shopify handle cart drawer if available */
        }
      });
    });
  }

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', function () {
    initScrollReveal();
    initStickyHeader();
    initSmoothScroll();
    initCart();
  });

}());
